import { render } from "./ToolCaptureSave.vue?vue&type=template&id=8117b19a&scoped=true"
import script from "./ToolCaptureSave.vue?vue&type=script&lang=js"
export * from "./ToolCaptureSave.vue?vue&type=script&lang=js"

import "./ToolCaptureSave.vue?vue&type=style&index=0&id=8117b19a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8117b19a"]])

export default __exports__